import { DragulaService } from 'ng2-dragula';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { TweenLite } from 'gsap';

import { AlertService } from '@shared/modules/alert';

import { CbDataTableOptions, CbDataTableColumnType, CbSort } from './cb-data-table-options';

@Component({
  moduleId: 'module.id',
  selector: 'cb-data-table',
  styles: [require('./cb-data-table.component.scss')],
  template: require('./cb-data-table.component.html')
})
export class CbDataTableComponent implements OnInit, OnDestroy {
  @Input()
  public options: CbDataTableOptions<any>;

  @Input()
  public data: any[];

  @Input()
  public deleteConfirmation: boolean = true;

  @Input()
  public hasActions: boolean = true;

  @Output()
  public delete = new EventEmitter();

  @Output()
  public edit = new EventEmitter();

  @Output()
  public rowSelect = new EventEmitter();

  @Output()
  public sortChange = new EventEmitter();

  @Output()
  public pageChange = new EventEmitter();

  @Output()
  public drop = new EventEmitter();

  @Input()
  public dragula: boolean;

  public dragulaId: string;

  private destroyed: boolean;

  constructor(private alertService: AlertService, private dragulaService: DragulaService) {
    this.dragulaId = Math.random() * 10000 + '';

    this.dragulaService.setOptions(this.dragulaId, {
      direction: 'vertical',
      moves:() => this.dragula
    });
  }

  // ===============================================================================================
  // Override Methods
  // ===============================================================================================

  public ngOnInit() {
    this.dragulaService.drop.takeWhile(() => !this.destroyed).subscribe(
      value => {
        let drag = value[1];
        let drop = value[4];
        let dragIndex = parseInt(drag.getAttribute('index'));
        let dropIndex = this.data.length;;

        if (drop) {
          dropIndex = parseInt(drop.getAttribute('index'));
        }

        if (dropIndex > dragIndex) {
          dropIndex -= 1;
        }

        this.drop.emit({
          dragIndex: dragIndex,
          dropIndex: dropIndex
        });

        console.log({
          dragIndex: dragIndex,
          dropIndex: dropIndex
        });
      }
    );
  }

  public ngOnDestroy() {
    this.destroyed = true;
    this.dragulaService.destroy(this.dragulaId);
  }

  // ===============================================================================================
  // Actions
  // ===============================================================================================

  public onPageChange(index: number) {
    this.options.pagination.page = index;
    this.pageChange.emit(index);
  }

  public onDelete(event: MouseEvent, row: number) {
    event.stopPropagation();

    if (!this.deleteConfirmation) {
      this.delete.emit(row);
      return;
    }

    this.alertService.showDeleteWarning().then((result: boolean) => {
      if (result) {
        this.delete.emit(row);
      }
    });
  }

  public onSort(sortKey: string) {
    if (this.options.sort && sortKey) {
      this.options.sort.sortKey = sortKey;
      this.options.sort.ascending = !this.options.sort.ascending;
      this.sortChange.emit(this.options.sort);
    }
  }

  public onEdit(event: MouseEvent, row: number) {
    event.stopPropagation();
    this.edit.emit(row);
  }

  public onRowSelect(row: number) {
    this.rowSelect.emit(row);
  }

  // ===============================================================================================
  // Public Methods
  // ===============================================================================================

  public isAscending(sortKey: string): boolean {
    return this.options.sort && this.options.sort.sortKey === sortKey  && this.options.sort.ascending === true;
  }

  public isDescending(sortKey: string): boolean {
    return this.options.sort && this.options.sort.sortKey === sortKey && this.options.sort.ascending === false;
  }

  public isTranslation(type: CbDataTableColumnType): boolean {
    return (type === CbDataTableColumnType.TRANSLATION);
  }

  public isText(type: CbDataTableColumnType): boolean {
    return (type === CbDataTableColumnType.TEXT);
  }

  public isDate(type: CbDataTableColumnType): boolean {
    return (type === CbDataTableColumnType.DATE);
  }

  public isCurrency(type: CbDataTableColumnType): boolean {
    return (type === CbDataTableColumnType.CURRENCY);
  }

  public isImage(type: CbDataTableColumnType): boolean {
    return (type === CbDataTableColumnType.IMAGE);
  }

  public isStatus(type: CbDataTableColumnType): boolean {
    return (type === CbDataTableColumnType.STATUS);
  }

  public isTag(type: CbDataTableColumnType): boolean {
    return (type === CbDataTableColumnType.TAG);
  }

  public isImageCircle(type: CbDataTableColumnType): boolean {
    return (type === CbDataTableColumnType.IMAGE_CIRCLE);
  }

  public isCompleted(o: any) {
    return this.progress(o) == 100;
  }

  public isProgressing(o: any) {
    let progress = this.progress(o);
    return progress > 0 && progress < 100;
  }

  public progress(o: any) {
    return this.options.progress ? this.options.progress(o) : 0;
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/cb-data-table/cb-data-table.component.ts